import React from "react";

import Carousel from "../../components/Carousel/Carousel";
import Home from "../Home/Home";
import SignIn from "../SignIn/SignIn";

const Main = () => {
    return(
         <>
 
    <br/>
    <Carousel/>
    <Home/>
    <SignIn/>
    </>
    )
}

export default Main;